import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import AppBar from "../../common/AppBar";
import { fetchProfile } from "../../redux/authSlice";

const ProfilePage = () => {
  const dispatch = useDispatch();
  const { user, loading, error } = useSelector((state) => state.auth);

  useEffect(() => {
    dispatch(fetchProfile());
  }, [dispatch]);

  if (loading) return <p>Loading profile...</p>;
  if (error) return <p className="error">{error}</p>;

  return (
    <div>
      <AppBar title="User Profile" showTablesDropdown={false} buttons={[]} />
      <div className="profile-container">
        <h2>Profile Information</h2>
        <div className="profile-details">
          <p>
            <strong>First Name:</strong> {user?.first_name}
          </p>
          <p>
            <strong>Last Name:</strong> {user?.last_name}
          </p>
          <p>
            <strong>Email:</strong> {user?.email}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ProfilePage;
